//Login
export const userLogin = () => `/api/adm/v1/administrator/admin/login`;
export const userLogout = () => `/api/adm/v1/administrator/admin/logout`;

//kompanija
export const getCompanyList = (id) =>
  id == 0 ? `/api/adm/v1/company/admin` : `/api/adm/v1/company/admin/${id}`;
export const pathCreateCompany = () => `/api/adm/v1/company/admin`;
export const getCompanyFormList = (id) =>
  `/api/adm/v1/company/admin/form?countryId=${id}`;

//proizvod
export const getProductList = (id) =>
  id == 0 ? `/api/plt/v1/product/admin` : `/api/plt/v1/product/admin/${id}`;
export const pathCreateProduct = () => `/api/plt/v1/product/admin`;
export const pathDeleteProduct = (id) => `/api/plt/v1/product/admin/${id}`;
export const postImportProduct = () => `/api/plt/v1/product/admin/import`;
export const postImportCategory = () => `/api/plt/v1/category/admin/import`;
export const getProductsListPromotion = (id) =>
  `/api/plt/v1/product/admin/form?countryId=${id}`;

//blog
export const getBlogList = (id) =>
  id == 0 ? `/api/plt/v1/blog/admin` : `/api/plt/v1/blog/admin/${id}`;
export const pathCreateBlog = () => `/api/plt/v1/blog/admin`;
export const pathDeleteBlog = (id) => `/api/plt/v1/blog/admin/${id}`;

//level
export const getLevelList = (id) =>
  id == 0 ? `/api/adm/v1/level/admin` : `/api/adm/v1/level/admin/${id}`;
export const pathCreateLevel = () => `/api/adm/v1/level/admin`;
export const pathDeleteLevel = (id) => `/api/adm/v1/level/admin/${id}`;

//edukacije
export const getEducationList = (id) =>
  id == 0 ? `/api/plt/v1/education/admin` : `/api/plt/v1/education/admin/${id}`;
export const pathCreateEducation = () => `/api/plt/v1/education/admin`;
export const pathDeleteEducation = (id) => `/api/plt/v1/education/admin/${id}`;
export const getEducationFormList = (id) =>
  `/api/plt/v1/education/admin/form?countryId=${id}`;

//pitanja
export const getQuestionList = (id) =>
  id == 0 ? `/api/plt/v1/question/admin` : `/api/plt/v1/question/admin/${id}`;
export const pathCreateQuestion = () => `/api/plt/v1/question/admin`;
export const pathDeleteQuestion = (id) => `/api/plt/v1/question/admin/${id}`;

//lekcije
export const getLessonList = (id) =>
  id == 0 ? `/api/plt/v1/lesson/admin` : `/api/plt/v1/lesson/admin/${id}`;
export const pathCreateLesson = () => `/api/plt/v1/lesson/admin`;
export const pathDeleteLesson = (id) => `/api/plt/v1/lesson/admin/${id}`;

//nagrade
export const getAwardList = (id) =>
  id == 0 ? `/api/plt/v1/reward/admin` : `/api/plt/v1/reward/admin/${id}`;
export const pathCreateAward = () => `/api/plt/v1/reward/admin`;
export const pathDeleteAward = (id) => `/api/plt/v1/reward/admin/${id}`;

export const pathDeleteClaimReward = (id) =>
  `/api/plt/v1/reward-claim/admin/cancel/${id}`;

export const getAwardOrderList = () => `/api/plt/v1/reward-claim/admin`;

export const pathActiveReward = (id) =>
  `/api/plt/v1/reward-claim/admin/approve/${id}`;
export const pathDeactiveReward = (id) =>
  `/api/plt/v1/reward-claim/admin/reject/${id}`;

//promocije
export const getPromotionList = (id) =>
  id == 0 ? `/api/plt/v1/promotion/admin` : `/api/plt/v1/promotion/admin/${id}`;
export const pathCreatePromotion = () => `/api/plt/v1/promotion/admin`;
export const pathDeletePromotion = (id) => `/api/plt/v1/promotion/admin/${id}`;
export const postImportPromotion = () => `/api/plt/v1/promotion/admin/import`;

//taskovi
export const getTaskList = (id) =>
  id == 0 ? `/api/adm/v1/task/admin` : `/api/adm/v1/task/admin/${id}`;
export const pathCreateTask = () => `/api/adm/v1/task/admin`;
export const pathDeleteTask = (id) => `/api/adm/v1/task/${id}`;
export const getTaskListDetail = (id) => `/api/adm/v1/task/admin/items/${id}`;

//notifikacije
export const getNotificationList = (id) =>
  id == 0
    ? `/api/ntf/v1/notification/admin`
    : `/api/ntf/v1/notification/admin/${id}`;
export const getNotificationSystemList = (id) =>
  id == 0
    ? `/api/ntf/v1/notification-template/admin`
    : `/api/ntf/v1/notification-template/admin/${id}`;
export const pathCreateNotification = () => `/api/ntf/v1/notification/admin`;
export const pathDeleteNotification = (id) =>
  `/api/ntf/v1/notification/admin/${id}`;
export const getNotificationListDetail = (id) =>
  `/api/ntf/v1/notification/admin/items/${id}`;
export const pathUpdateSystemNotification = () =>
  `/api/ntf/v1/notification-template/admin`;

//gallery
export const getGalleryList = (id) =>
  id == 0 ? `/api/plt/v1/gallery/admin` : `/api/plt/v1/gallery/admin/${id}`;
export const pathCreateGallery = () => `/api/plt/v1/gallery/admin`;
export const pathDeleteGallery = (id) => `/api/plt/v1/gallery/admin/${id}`;

//country
export const getCountryList = (id) =>
  id == 0 ? `/api/adm/v1/country/admin` : `/api/adm/v1/country/admin/${id}`;
export const pathCreateCountry = () => `/api/adm/v1/country/admin`;
export const getCountryFormList = (id) => `/api/adm/v1/country/admin/form`;

//role
export const getRoleList = (id) =>
  id == 0 ? `/api/adm/v1/role/admin` : `/api/adm/v1/role/admin/${id}`;
export const pathCreateRole = () => `/api/adm/v1/role/admin`;
export const pathDeleteRole = (id) => `/api/adm/v1/role/admin/${id}`;

//radnje
export const getStoreList = (id) =>
  id == 0 ? `/api/adm/v1/store/admin` : `/api/adm/v1/store/admin/${id}`;
export const pathCreateStore = () => `/api/adm/v1/store/admin`;
export const pathChangeStoreCustomer = () =>
  `/api/adm/v1/account/admin/change-store`;
export const pathChangeTypeCustomer = () =>
  `/api/adm/v1/account/admin/change-type`;
export const getStoreFormExtendedList = (country) =>
  `/api/adm/v1/store/admin/form/extended?countryId=${country}`;
export const getStoreFormList = (companyId) =>
  `/api/adm/v1/store/admin/form?companyId=${companyId}`;

//adminitstratori sistema
export const getUserList = (id) =>
  id == 0
    ? `/api/adm/v1/administrator/admin`
    : `/api/adm/v1/administrator/admin/${id}`;
export const pathUserAdministration = () => `/api/adm/v1/administrator/admin`;

//verifikacija koda kod logina
export const userLoginVerify = () =>
  `/api/adm/v1/administrator/admin/login-verify`;

//korisnici
export const getCustomerList = (id) =>
  id == 0 ? `/api/adm/v1/account/admin` : `/api/adm/v1/account/admin/${id}`;
export const pathCustomerAdministration = () => `/api/adm/v1/account/admin`;
export const pathActiveCustomer = (id) =>
  `/api/adm/v1/account/admin/activate/${id}`;
export const pathDeactiveCustomer = (id) =>
  `/api/adm/v1/account/admin/deactivate/${id}`;
export const getMenu = () => `/api/adm/v1/menu/admin/form`;
export const getCustomerExtendedFormList = (country, sector = "") =>
  sector
    ? `/api/adm/v1/account/admin/form/extended?countryId=${country}&sector=${sector}`
    : `/api/adm/v1/account/admin/form/extended?countryId=${country}`;

//kategorije proizvoda
export const getProductCategoryList = (id) =>
  id == 0 ? `/api/plt/v1/category/admin` : `/api/plt/v1/category/admin/${id}`;
export const pathCreateProductCategory = () => `/api/plt/v1/category/admin`;
export const pathDeleteProductCategory = (id) =>
  `/api/plt/v1/category/admin/${id}`;
export const getProductCategoryFormList = (id) =>
  `/api/plt/v1/category/admin/form?countryId=${id}`;

//kategorije proizvoda
export const getEducationCategoryList = (id) =>
  id == 0
    ? `/api/plt/v1/education-category/admin`
    : `/api/plt/v1/education-category/admin/${id}`;
export const pathCreateEducationCategory = () =>
  `/api/plt/v1/education-category/admin`;
export const pathDeleteEducationCategory = (id) =>
  `/api/plt/v1/education-category/admin/${id}`;
export const getEducationCategoryFormList = (id) =>
  `/api/plt/v1/education-category/admin/form?countryId=${id}`;

//porudzbine
export const pathActiveReceipt = (id) =>
  `/api/plt/v1/receipt/admin/approve/${id}`;
export const pathReactiveReceipt = (id) =>
  `/api/plt/v1/receipt/admin/reapprove/${id}`;
export const pathDeactiveReceipt = (id) =>
  `/api/plt/v1/receipt/admin/reject/${id}`;
export const pathReDeactiveReceipt = (id) =>
  `/api/plt/v1/receipt/admin/rereject/${id}`;

export const getReceiptList = (id) =>
  id === 0 ? `/api/plt/v1/receipt/admin` : `/api/plt/v1/receipt/admin/${id}`;

export const addPointsCustomer = () => "api/adm/v1/point-record/admin";
export const changeSectorCustomer = () =>
  "api/adm/v1/account/admin/change-sector";
export const removePointsCustomer = () =>
  "api/adm/v1/point-record/remove-points";

export const getChatPath = () => "/api/adm/v1/chat/admin";
export const getChatDetailPath = (id, page, size) =>
  `/api/adm/v1/message/admin/${id}?page=${page}&size=${size}`;
export const getChatSendPath = () => `/api/adm/v1/message/admin`;

export const getDashboarData1 = () => "/api/adm/v1/account/admin/dashboard";
export const getDashboarData2 = () =>
  "/api/adm/v1/account/admin/dashboard/country";
export const getDashboarDataTask = () => "/api/adm/v1/task/admin/dashboard";
export const getDashboarDataReward = () => "/api/plt/v1/reward/admin/dashboard";
export const getDashboarDataProduct = () =>
  "/api/plt/v1/product/admin/dashboard";
export const getDashboarDataBestSale = () =>
  "/api/plt/v1/receipt/admin/dashboard/best-sale";
export const getDashboarDataPerMonth = () =>
  "/api/plt/v1/receipt/admin/dashboard/per-month";

export const receiptReport = (data) =>
  `api/plt/v1/report/receipt-report?dateFrom=${data.dateFrom}&dateTo=${data.dateTo}&countryId=${data.countryId}`;
export const receiptManagerReport = (data) =>
  `api/plt/v1/report/receipt-manager-report?dateFrom=${data.dateFrom}&dateTo=${data.dateTo}&countryId=${data.countryId}`;
export const educationReport = (data) =>
  `api/plt/v1/report/education-report?dateFrom=${data.dateFrom}&dateTo=${data.dateTo}&countryId=${data.countryId}`;
export const additionalPointReport = (data) =>
  `api/plt/v1/report/additional-point-report?dateFrom=${data.dateFrom}&dateTo=${data.dateTo}&countryId=${data.countryId}`;
